<template>
  <div class="container">
    <el-table :data="list" border style="" align="center">
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="编号"
      >
      </el-table-column>
      <el-table-column
        prop=""
        label="标签"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover ref="popover1" placement="top-start" trigger="hover">
            <span slot="reference">{{ scope.row.batch_tag }}</span>
            <span>{{ batchTagToText(scope.row) }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="食堂">
        <template>
          {{ eatery.eatery_name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="marker_username"
        label="标注人"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="checker_username"
        label="审核人"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column label="标注时间" header-align="center" align="center">
        <template slot-scope="scope">
          {{ tsTodatetime(scope.row.marked_time) }}
        </template>
      </el-table-column>
      <el-table-column label="审核时间" header-align="center" align="center">
        <template slot-scope="scope">
          {{ tsTodatetime(scope.row.last_checked_time) }}
        </template>
      </el-table-column>
      <el-table-column label="批次状态" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="isMigrated(scope.row)">
            <el-tag type="danger">迁移批次</el-tag>
          </span>
          <span v-else>
            <el-tag v-if="scope.row.batch_state === 0" type="danger">{{
              stateOptions[scope.row.batch_state].state
            }}</el-tag>
            <el-tag v-if="scope.row.batch_state === 1" type="primary">{{
              stateOptions[scope.row.batch_state].state
            }}</el-tag>
            <el-tag v-if="scope.row.batch_state === 2" type="primary">{{
              stateOptions[scope.row.batch_state].state
            }}</el-tag>
            <div>
              <el-tag
                style="display: inline-block"
                v-if="scope.row.batch_state === 3"
                type="success"
                >{{ stateOptions[scope.row.batch_state].state }}</el-tag
              >
            </div>
            <el-tag
              v-if="scope.row.batch_state === 4"
              :plain="true"
              size="mini"
              type="danger"
            >
              {{ stateOptions[scope.row.batch_state].state }}
              <i class="el-icon-question"></i>
            </el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="审查意见"
      >
        <template slot-scope="scope" v-if="scope.row.batch_state === 4">
          {{`${parserCheckObjList(scope.row.batch_comment).length}张错误`}}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope">
          <!-- // v-if="scope.row.batch_state === 0" -->
          <span v-if="isMigrated(scope.row)">
            <el-tag type="danger">迁移批次无需标注</el-tag>
          </span>
          <span v-else>
            <span v-if="markButtonShow">
              <el-button
                type="text"
                v-if="scope.row.batch_state === 0"
                @click="startMark(scope.row);"
                >标注</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.batch_state === 1 && isCommonUser(scope.row)"
                @click="startMark(scope.row);"
              >
                继续标注</el-button
              >
              <el-button
                type="danger"
                :plain="true"
                size="mini"
                v-if="scope.row.batch_state === 1 && isCommonUser(scope.row)"
                @click="cancelMark(scope.row);"
                >取消</el-button
              >
              <el-tag
                type="danger"
                v-if="scope.row.batch_state === 1 && !isCommonUser(scope.row)"
                >其他用户标注中</el-tag
              >
              <el-button
                type="text"
                v-if="scope.row.batch_state === 3"
                @click="startMark(scope.row);"
              >重新标注</el-button
              >
              <!-- // 审核不通过 -->
              <!-- // 重新标注 -->
              <!-- // 自查 -->
            <el-button
              type="text"
              v-if="scope.row.batch_state === 4"
              @click="startMark(scope.row);"
            >重新标注</el-button
            >
            </span>
            <span v-else>
              <el-button
                type="text"
                v-if="scope.row.batch_state === 2 && userGroup > 99"
                @click="startCheck(scope.row);"
              >审核</el-button
              >
            </span>
            <!-- // 审核通过 batch_state === 3 -->
            <!-- // 自查 -->
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="请选择用于切割的模型"
      :visible.sync="baseModelDialogShow"
      width="60%">
      <el-table
        :data="baseModelList"
        style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="#"
        >
        </el-table-column>
        <el-table-column
          prop="date"
          label="生成时间">
          <template slot-scope="scope">
            {{tsTodatetime(scope.row.model_ts)}}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="markByModel(scope.row)">使用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import {apiBaseModelList, apiBatchChange, apiChangeBatchState, apiGetCollectInference} from '@/api';
import {mapGetters, mapMutations} from 'vuex';
import {errorMessage} from '@/lib/msg';
import util from '@/lib/util';

export default {
  name: 'batchTable',
  props: {
    batchList: {
      type: Array,
      default () {
        return [
          {
            batch_tag: '1-tag-1',
            // "marker_id": "<int>",//标注人id
            marker_username: '<string>', // 标注人用户名
            // "checker_id": "<int>",//审核员id
            checker_username: '<string>', // 审核员用户名 可能为null
            batch_state: '<enum>', // 批次状态 0未标注 1标注中 2标注完成待审核 3审核通过并存档 4审核不通过
            batch_comment: '<string>', // 批次注释（审核不通过的理由）
            start_mark_time: '<utc_timestamp>', // 开始标注时间
            marked_time: '<utc_timestamp>', // 标注完成时间 可能为null
            last_checked_time: '<utc_timestamp>' // 上次审核时间 可能为null
          }
        ];
      }
    },
    eatery: {},
    canteen: {}
  },
  data () {
    return {
      baseModelDialogShow: false,
      stateOptions: [
        { index: 0, state: '未标注' },
        { index: 1, state: '标注中' },
        { index: 2, state: '待审核' },
        { index: 3, state: '审核通过' },
        { index: 4, state: '审核不通过' }
      ],
      baseModelList: []
    };
  },
  mounted () {
    this.setSubTitle('批次列表');
    this.getBaseModlelList();
  },
  methods: {
    ...mapMutations(['setBatchTag', 'setSubTitle', 'setUnMarkedImageList']),
    async getBaseModlelList () {
      try {
        let res = await apiBaseModelList({canteen_id: this.canteen.canteen_id, apiKey: this.apiKey});
        if (res.state_code === 0) {
          this.baseModelList = res.data.model_list || [];
          this.baseModelList.sort((a, b) => {
            return b.model_ts - a.model_ts;
          });
        } else {
          return this.$message.error('获取模型列表失败');
        }
      } catch (e) {
        this.$message.error('获取模型列表失败');
      }
    },
    parserCheckObjList (checkListObj) {
      if (checkListObj) {
        try {
          return JSON.parse(checkListObj);
        } catch (e) {
          return checkListObj;
        }
      } else {
        return [];
      }
    },
    // 判断是否是同一用户
    isCommonUser (row) {
      return row.marker_username === this.userinfo().username;
    },
    isMigrated (row) {
      let tagArray = row.batch_tag.split('-');
      return tagArray.indexOf('qianyi') !== -1;
    },
    batchTagToText (row) {
      let tagArray = row.batch_tag.split('-');
      if (tagArray.indexOf('qianyi') !== -1) {
        return `迁移批次, ${moment(tagArray[0] * 1000).format('YY年MM月DD日')}`;
      } else {
        return `普通批次, ${moment(tagArray[0] * 1000).format('YY年MM月DD日')}`;
      }
    },
    tagToIndex (tag) {
      return tag;
    },
    tsTodatetime (ts) {
      if (!ts) {
        return '-';
      } else {
        if (ts.toString().length === 13) {
          return moment(ts).format('YYYY-MM-DD');
        } else {
          return moment(ts * 1000).format('YYYY-MM-DD');
        }
      }
    },
    cancelMark (row) {
      row.batch_state = 0;
      let { system_id, batch_tag, batch_state, batch_comment } = row;
      apiChangeBatchState({
        system_id,
        batch_tag,
        batch_state,
        batch_comment,
        apiKey: this.apiKey
      }).then(res => {
        this.setBatchTag('');
        this.setUnMarkedImageList([]);
        errorMessage('您已取消标注');
      });
    },
    async markByModel (row) {
      let newestModel = row;
      try {
        await apiGetCollectInference({
          canteen_id: this.canteen.canteen_id,
          model_uuid: newestModel.model_uuid,
          date_range: {
            start_ts: util.dateToUnixtimestamp(this.listQuery.dateRange[0], 0),
            end_ts: util.dateToUnixtimestamp(this.listQuery.dateRange[1], 1)
          }
        });
        this.baseModelDialogShow = false;
        this.$message.warning('检测成功');
      } catch (e) {
        console.log(e);
        this.baseModelDialogShow = false;
        this.$message.error('检测失败');
      }
    },
    async markByHuman (row) {
      if (this.batchTag && this.batchTag !== row.batch_tag) {
        errorMessage('当前已有正在进行的标注任务, 请取消或者继续标注');
      } else {
        let tag = row.batch_tag;
        if (tag.split('-').length === 5) {
          try {
            let { batch_tag } = await apiBatchChange(tag);
            row.batch_tag = batch_tag;
          } catch (e) {
            console.log(e);
          }
        }
        row.batch_state = 1;
        let { system_id, batch_tag, batch_state, batch_comment } = row;
        apiChangeBatchState({
          system_id,
          batch_tag,
          batch_state,
          batch_comment,
          apiKey: this.apiKey
        }).then(res => {
          console.log(res);
        });
        this.setBatchTag(batch_tag);
        this.$router.push({
          path: 'markProcess1',
          query: {
            checkTextObj: this.parserCheckObjList(row.batch_comment),
            canteen: this.canteen,
            eatery: this.eatery
          }
        });
      }
    },
    async startMark (row) {
      // todo: 判断该餐厅是否有模型
      let model_list = this.baseModelList;
      if (model_list && model_list.length > 0) {
        // 有模型., 通过检测自动标注
        model_list.sort((a, b) => {
          return b.model_ts - a.model_ts;
        });
        let confirm = await this.$confirm('检测到有可用的模型, 是否使用模型进行标注?', '提示', {
          confirmButtonText: '使用模型',
          cancelButtonText: '人工标注'
        }).catch(() => {
          this.markByHuman(row);
        });
        let newestModel = model_list[0];
        this.$message.warning('正在进行模型标注, 请稍后...');
        // 通过检测标注
        // this.markByModel();
        this.baseModelDialogShow = true;
      } else {
        // 无模型
        this.$message.error('此餐厅无模型, 请手动标注');
        this.markByHuman(row);
      }
    },
    startCheck (row) {
      if (this.userinfo().userGroup < 100) {
        errorMessage('对不起，您暂无审核权限');
      } else {
        let { system_id, batch_tag, batch_state, batch_comment } = row;
        this.setBatchTag(batch_tag);

        this.$router.push({
          path: 'checkProcess'
          // query: {
          //   batch_tag: row.batch_tag
          // }
        });
      }
    }
  },
  filters: {
    // tsTodatetime (ts) {
    //   return moment(ts * 1000).format('YYYY-MM-DD');
    // }
  },
  computed: {
    ...mapGetters(['userinfo', 'batchTag', 'listQuery']),
    apiKey () {
      return this.userinfo().api_key;
    },
    markButtonShow () {
      console.log(this.$route.fullPath);
      return this.$route.name === 'batchList';
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    list () {
      return this.batchList;
    }
  }
};
</script>
<style></style>
